import { useSelector } from 'react-redux'

import KinesisEventCalendarEventItem from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/KinesisEventCalendarEventItem'
import PastKinesisWorkoutCalendarEventItem from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/PastKinesisWorkoutCalendarEventItem'
import ActiveKinesisWorkoutCalendarEventItem from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/ActiveKinesisWorkoutCalendarEventItem'
import FutureKinesisWorkoutCalendarEventItem from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/FutureKinesisWorkoutCalendarEventItem'
import TrainingPeaksWorkoutCalendarEventItem from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/TrainingPeaksWorkoutCalendarEventItem'

export default function CalendarEventItemRouter({ eventData }) {

    const profileType = useSelector((state) => state.athleteProfile.profileType)
    
    const GetClassName = () => {

        var className = 'w-full p-1 bg-white border-t-[3px] border-gray-300 rounded-md shadow cursor-pointer hover:shadow-md'

        if (eventData.extendedProps.calendarEventType === 'kinesis-workout'){

            if (profileType === 'group') {
                className = className.replace('bg-white', 'bg-orange-50')
                className = className.replace('border-gray-300', 'border-orange-400')
                return className
            }
            
            if (eventData.extendedProps.calendarDataKey === 'past'){
                if (eventData.extendedProps.completionData.completed === true) {
                    className = className.replace('bg-white', 'bg-green-50')
                    className = className.replace('border-gray-300', 'border-green-300')
                }
    
                if (eventData.extendedProps.completionData.completed === false) {
                    className = className.replace('bg-white', 'bg-red-50')
                    className = className.replace('border-gray-300', 'border-red-300')
                }
            }

            if (eventData.extendedProps.calendarDataKey === 'active'){
                if (eventData.extendedProps.completionData.completed === true) {
                    className = className.replace('bg-white', 'bg-green-50')
                    className = className.replace('border-gray-300', 'border-green-300')
                }

                if (
                    eventData.extendedProps.completionData.completed === false
                    && eventData.extendedProps.isInThePast === true
                ) {
                    className = className.replace('bg-white', 'bg-red-50')
                    className = className.replace('border-gray-300', 'border-red-300')
                }

                if (
                    eventData.extendedProps.completionData.completed === false
                    && eventData.extendedProps.isInThePast === false
                ) {
                    className = className.replace('bg-white', 'bg-orange-50')
                    className = className.replace('border-gray-300', 'border-orange-400')
                }
            }

            if (eventData.extendedProps.calendarDataKey === 'future'){
                className = className.replace('bg-white', 'bg-orange-50')
                className = className.replace('border-gray-300', 'border-orange-400')
            }

        }
        
        if (eventData.extendedProps.calendarEventType === 'training-peaks-workout'){
            className = className.replace('bg-white', 'bg-blue-50')
            className = className.replace('border-gray-300', 'border-blue-400')
        }
        
        return className
    }

    return (
        <div className='w-full px-1'>
            <div className={GetClassName()}>
                {/* <p className='text-xxs text-gray-500'>{eventData.extendedProps.calendarEventType}</p> */}
                
                {eventData.extendedProps.calendarEventType === 'kinesis-event' && <KinesisEventCalendarEventItem eventData={eventData} />}

                {eventData.extendedProps.calendarEventType === 'kinesis-workout' && 
                    <>
                        {/* <p className='text-xxs text-gray-500'>{eventData.extendedProps.calendarDataKey}</p> */}

                        {eventData.extendedProps.calendarDataKey === 'past' && <PastKinesisWorkoutCalendarEventItem eventData={eventData} />}

                        {eventData.extendedProps.calendarDataKey === 'active' && <ActiveKinesisWorkoutCalendarEventItem eventData={eventData} />}

                        {eventData.extendedProps.calendarDataKey === 'future' && <FutureKinesisWorkoutCalendarEventItem eventData={eventData} />}
                    </>
                }

                {eventData.extendedProps.calendarEventType === 'training-peaks-workout' && <TrainingPeaksWorkoutCalendarEventItem eventData={eventData} />}
            </div>
        </div>
    )
}